// Generated by `yarn tokens:import --aos-ds` from the Figma component set "Link" (6341:72183). Do not edit.
//
// The "state" axis is interaction state, so it is not a prop: hover and hovered are `hover:`, pressed is `active:`, focus is `focus:`,
// and disabled is applied in JS because react-native-web renders a div, which
// Tailwind's `disabled:` never matches.

import type { FigmaGlyph } from '../../icons/glyph'

export type ContractProp =
    | { kind: 'enum'; values: readonly string[] }
    | { kind: 'boolean' }
    | { kind: 'text' }
    | { kind: 'instance_swap' }
    // A matrix can carry slots too — Modal/Footer has two.
    | { kind: 'slot' }

export type ContractComposition = { component: string; variants: readonly string[] }

// A place the Figma file contradicts itself, grouped by what it says. `count` is
// how many places say it; `property` and `stated` are set for an alignment the
// file states and does not draw.
export type ContractDisagreement = {
    note: string
    count: number
    property?: string
    stated?: string
}

export type ContractVariant = {
    container: string
    label: string
    // The surface, when the paint sits on a child rather than the root:
    // empty for every component that paints its own frame.
    box: string
    // Every named node the variant draws beyond those two, keyed by the
    // name Figma gives it. A key that reads as a value rather than a role
    // means the component is a composition, not a primitive.
    parts: Record<string, string>
    // The shape of every part that is one — a VECTOR drawn on top of
    // something the variant also paints, which the whole-variant `glyph`
    // cannot describe because that one requires no paint at all.
    glyphs: Record<string, FigmaGlyph>
    // The glyph the variant draws, inked separately from the label.
    icon: string
    // Applied in JS: `disabled:` never matches a react-native-web div, and
    // `:visited` exists only on an anchor.
    disabled: string
    visited: string
    // Which of `textStyleIds` each text part is set in. The ids are a set,
    // so a component with two says two exist and not which part uses which.
    partTextStyles: Record<string, string>
    // What this cell instantiates, and which variant of it.
    composes: readonly ContractComposition[]
}

export const linkContract = {
    component: 'Link',
    nodeId: '6341:72183',
    section: '[Web] Primitives',
    composes: [] as readonly ContractComposition[],
    stateAxis: 'state',
    // Where the caller puts content. One `ReactNode` prop per name.
    slots: [] as readonly string[],
    // What the file says that its own drawing does not show.
    disagreeing: [
        {
            note: 'primaryAxisAlignItems CENTER on a row that hugs — no slack to align in, so the file states an alignment it does not draw',
            count: 5,
            property: 'primaryAxisAlignItems',
            stated: 'CENTER',
        },
        {
            note: 'textAlignHorizontal CENTER on a HUG text — renders left, so the file states an alignment it does not draw',
            count: 10,
            property: 'textAlignHorizontal',
            stated: 'CENTER',
        },
    ] as readonly ContractDisagreement[],
    textStyleIds: ['S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,'],
    props: {
        text: { kind: 'text' },
    },
    variants: {
        default: {
            container: 'group/link gap-s items-center',
            label: 'text-content-link text-left group-hover/link:text-content-link-hover group-active/link:text-content-link-pressed',
            icon: '',
            disabled: 'opacity-disabled',
            visited: 'text-content-link-visited',
            box: '',
            parts: {
                Link: 'text-content-link text-left group-hover/link:text-content-link-hover group-active/link:text-content-link-pressed',
            },
            glyphs: {} as Record<string, FigmaGlyph>,
            partTextStyles: {
                Link: 'S:ab7c4fdfb951974b07e9f2c1fced98aecc30762c,',
            } as Record<string, string>,
            composes: [],
        },
    },
} as const satisfies {
    component: string
    nodeId: string
    section: string
    composes: readonly ContractComposition[]
    stateAxis: string | null
    slots: readonly string[]
    disagreeing: readonly ContractDisagreement[]
    textStyleIds: readonly string[]
    props: Record<string, ContractProp>
    variants: Record<string, ContractVariant>
}
